import axiosInstance from '../../api/axiosInstance';

export const Paymentallocation = async (payload) => {
    const response = await axiosInstance.post('/wealth/update-allocation', payload);
    return response.data;
};

export const ContactUs = async (payload) => {
    const response = await axiosInstance.post('/contact-us', payload);
    return response.data;
};

export const UserPortfolio = async (payload) => {
    const response = await axiosInstance.get(`/wealth/user-portfolio-details?userId=${payload}`);
    return response.data;
};

export const AddFund = async (payload) => {
    const response = await axiosInstance.post('/inv-user-fund', payload);
    return response.data;
};

export const UserEtf = async (payload) => {
    const response = await axiosInstance.get(`/inv-portfolio/2/portfolio`);
    return response.data;
};

export const GetAddedFundList = async () => {
    const uid = localStorage.getItem("uid")
    const response = await axiosInstance.get(`/inv-user-fund?userId=${uid}`);
    return response.data;
};

export const CheckAllocation = async (payload) => {
    const response = await axiosInstance.get(`/inv-user-fund/check-allocation/${payload}`);
    return response.data;
};

export const AddAllocationFund = async (payload,id) => {
    const response = await axiosInstance.post(`/inv-user-fund/allocate-fund/${id}`, payload);
    return response.data;
};